import { type FC, type ComponentProps } from 'react';
import Popup from '../Popup';

const br = '%0D%0A';
const supportLink = `
mailto:info@volosports.com?subject=👋
&body=${br}${br}${br}------------------------${br}${br}
Thanks for reaching out to Volo. If you're experiencing issues, the below information can help us help you.${br}${br}
Device (iPhone X, PC, etc): ${br}
Browser (Chrome, Edge, etc): ${br}
Email connected to your Volo account: ${br}
League(s) you're currently in: ${br}
Description of the problem you're experiencing: ${br}

`;

const SupportPopup: FC<ComponentProps<typeof Popup>> = props => (
  <Popup {...props}>
    <div className="text-left">
      <div>
        <div className="text-left">
          <div>
            <h2 style={{ fontWeight: 500 }} className="mb-2">
              For a majority of questions
            </h2>
            <p>
              Contact the host of the program you have questions about or are trying to register
              for. You can find host contact information on program pages under <i>Contact host</i>.
            </p>
          </div>
        </div>
        <div className="mt-4">
          <h2 style={{ fontWeight: 500 }} className="mb-2">
            For technical support
          </h2>
          <p>
            For <u>technical issues only</u> (login, signup, bugs, etc.), please reach out to{' '}
            <a href={supportLink}>info@volosports.com</a>.
          </p>
        </div>
      </div>
    </div>
  </Popup>
);

export default SupportPopup;
